import React, { Component } from 'react'
import { connect } from 'react-redux'

import './referenceorderapprovalmodal.scss'

// Components
import Modal from '../../components/Modal'
import ReferenceCancel from './ReferenceCancel'
import ReferenceApproval from './ReferenceApproval'
import MigrationInfo from './MigrationInfo'

// Actions
import { GetReferenceOrderInfo } from '../../../actions/orders'

// Utils
import { translation } from '../../../utils/helpers'
import { hasAccess } from '../../../utils/auth'

// Elements
// import { ReferenceIcons } from '../../elements/icons'

class ReferenceOrderActionModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      referenceInfo: {
        OrderConnectionId: 0,
        TransferedFromCompanyName: '',
        MoveType: 0,
        OrderInfo: {
          Orderid: 0,
          RegNumber: '',
          Brand: '',
          Model: '',
          Color: '',
          Price: 0,
          Pickup: undefined,
          Delivery: undefined
        },
        TransportBefore: '',
        TransportAfter: '',
        CustomerId: 0,
        CustomerName: '',
        IsWorkProviderOrder: false,
        PermittedCustomers: [],
        HasReferredOldway: false
      },
      isLoading: true,
      dimensions: {
        width: 0,
        height: 0
      },
      showMigrationModal: false,
      bottomBarProps: null
    }

    this.updateDimensions = this.updateDimensions.bind(this)
    this.dimensionShow = this.dimensionShow.bind(this)
    this.getReferenceOrderInfo = this.getReferenceOrderInfo.bind(this)
    this.setBottomBarProps = this.setBottomBarProps.bind(this)
  }

  componentDidMount () {
    if (!hasAccess([1, 2, 3, 4], this.props.auth.user.AccessLevel)) {
      window.toastr.error(translation('16417'), translation('216'))
      this.props.onClose()
      return null
    }

    this.getReferenceOrderInfo()
    window.addEventListener('resize', this.updateDimensions)
    this.updateDimensions()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width <= lessThan) show = true
      }
    })
    return show
  }

  getReferenceOrderInfo () {
    this.props.GetReferenceOrderInfo(this.props.id).then((res) => {
      this.setState({
        referenceInfo: res.data,
        isLoading: false
      })
    }, () => {
      window.toastr.error(translation('1932'), translation('216'))
      this.props.onClose()
    })
  }

  setBottomBarProps (bottomBarProps) {
    this.setState({ bottomBarProps: bottomBarProps })
  }

  renderView () {
    const loadingSpinner = () => {
      return (
        <div className='white__box loading'>
          <div className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <span className='sr-only'>{translation('13382')}...</span>
          </div>
        </div>
      )
    }
    let isLoading = this.state.isLoading
    if (isLoading) {
      return (
        <form>
          <div className='referenceGroup'>
            <strong>{translation('13382')}...</strong>
            {loadingSpinner()}
          </div>
        </form>
      )
    }

    const onClose = (IsApproved) => {
      if (this.state.referenceInfo.HasReferredOldway && IsApproved) {
        this.setState({
          showMigrationModal: true
        })
      } else {
        this.props.onClose()
      }
    }

    if (this.state.referenceInfo.IsApproved) {
      return (
        <ReferenceCancel
          referenceInfo={this.state.referenceInfo}
          department={this.props.department}
          dimensionShow={this.dimensionShow}
          onClose={this.props.onClose}
          setBottomBarProps={this.setBottomBarProps}
        />
      )
    } else {
      return (
        <ReferenceApproval
          referenceInfo={this.state.referenceInfo}
          department={this.props.department}
          dimensionShow={this.dimensionShow}
          onClose={onClose}
          setBottomBarProps={this.setBottomBarProps}
        />
      )
    }
  }

  render () {
    // Permission is handeld in "componentDidMount"

    let icon
    // if (this.state.referenceInfo.IsApproved) {
    //   icon = ReferenceIcons.Referred_Approved
    //   // icon = 'referred-order-white-red.svg'
    // } else {
      // icon = ReferenceIcons.Referred_NotApproved
      // icon = 'referred-order-white.svg'
    // }

    var headerName = this.props.item.Model ? this.props.item.Model : '' + ' ' + this.props.item.RegNumber

    if (this.state.showMigrationModal) {
      return (
        <div className='refOrderApproval migration'>
          <Modal {...this.props}
            header={this.state.referenceInfo.CustomerName}
            overflowHidden={this.state.overflowHidden}
            onClose={this.props.onClose}
            bottomBarProps={this.state.bottomBarProps}
          >
            <MigrationInfo
              onClose={this.props.onClose}
              customerId={this.state.referenceInfo.CustomerId}
              setBottomBarProps={this.setBottomBarProps}
            />
          </Modal>
        </div>
      )
    }

    return (
      <div className='refOrderApproval'>
        <Modal {...this.props}
          header={translation('751') + ' - ' + headerName}
          overflowHidden={this.state.overflowHidden}
          onClose={this.props.onClose}
          icon={icon}
          bottomBarProps={this.state.bottomBarProps}
        >
          {this.renderView()}
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  GetReferenceOrderInfo
})(ReferenceOrderActionModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/index.js